import styled from '@emotion/styled';

export const StyledDetailHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  label.detail-title {
    flex: 1;
    color: #333333;
    height: 48px;
    font-family: Noto Sans KR;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 44px;
    margin: 0 20px 0 12px;
  }
`;

export const StyledTabsWrapper = styled.div`
  margin-top: 10px;
`;

export const StyledTabs = styled.ul<{ tab: 'statistics' | 'details' }>`
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 14px;

  li {
    width: 136px;
    text-align: center;
    line-height: 38px;
    color: #999999;
    cursor: pointer;

    &.active {
      color: #00bf00;
      font-weight: 600;

      &:before {
        content: '';
        position: absolute;
        width: 136px;
        height: 2px;
        left: ${(props) => (props.tab === 'statistics' ? 0 : 136)}px;
        bottom: 0;
        z-index: 9;
        background-color: #00bf00;
      }
    }
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #999999;
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledBackButton = styled.button`
  position: relative;
  width: 24px;
  height: 24px;
  background-color: #00bf00;
  border-radius: 50%;

  &:after,
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 7px;
    height: 2px;
    background-color: #fff;
  }

  &:after {
    transform: translateX(-50%) translateY(calc(-50% + 2.5px)) rotateZ(45deg);
  }

  &:before {
    transform: translateX(-50%) translateY(calc(-50% - 2.5px)) rotateZ(-45deg);
  }
`;
